// Hero Scroller
export default function contactForm() {
    const form = document.querySelector('form#contact-form');

    if (!form) return;

    form.addEventListener('submit', e => {
        e.preventDefault()

        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());

        const isValid = validate(data)
        if (!isValid) return

        submit(data)
    })

    form.querySelectorAll('input, select').forEach(field => {
        field.addEventListener('change', () => {
            let isValid = true;
            if (field.name == 'email') {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                isValid = emailPattern.test(field.value)
            }

            else if (['fullname', 'companyname', 'jobtitle', 'about'].includes(field.name)) {
                isValid = !!field.value.trim()
            }
            if (isValid) {
                field.classList.remove('incorrect');
            } else {
                field.classList.add('incorrect');
            }
        })
    });

    const validate = (data) => {
        form.querySelectorAll('input, select').forEach(field => field.classList.remove('incorrect'));

        let isValid = true;

        if (!data.fullname.trim()) {
            form.elements.fullname.classList.add('incorrect');
            isValid = false;
        }

        if (!data.companyname.trim()) {
            form.elements.companyname.classList.add('incorrect');
            isValid = false;
        }

        if (!data.jobtitle.trim()) {
            form.elements.jobtitle.classList.add('incorrect');
            isValid = false;
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(data.email)) {
            form.elements.email.classList.add('incorrect');
            isValid = false;
        }

        if (!data.about) {
            form.elements.about.classList.add('incorrect');
            isValid = false;
        }

        return isValid
    }

    const submit = async (data) => {
        try {
            form.querySelector('button').textContent = 'Submitting'

            const response = await fetch('https://rcf-919718047811.us-east4.run.app', { // Change URL to /api/contact/
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            // Sussess response
            alert(result.message || 'Thanks for contacting us!');

            if (response.ok) {
                form.reset();
            }
        } catch (error) {
            // Error response
            console.error('Submission failed:', error);
            alert('Something went wrong. Please try again later.');
        } finally {
            form.querySelector('button').textContent = 'Submit'
        }
    }
}
